import _toConsumableArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 接口api
import { getAttendance, attendanceExcel } from 'api/Attendance';
// 获取在职状态
import { sysInfoFn as _sysInfoFn } from 'api/org/per';
// 部门
import department from '@/components/department';
// 职位
import job from '@/components/jobSelect';
// 时间选择
import datePacker from '@/components/date-picker';
// 色值 选项
import { colors, checkData } from './config';
// 详情
import punchDialog from './punch-dialog';
// 加班详情dialog
import otDialog from './components/ot-dialog';
import AttendanceDetailsDialog from './AttendanceDetailsDialog.vue';
// 批量导入考勤弹窗
import BatchImportDialog from './components/batch-import-dialog/index.vue';
export default {
  name: 'statis',
  components: {
    department: department,
    job: job,
    datePacker: datePacker,
    punchDialog: punchDialog,
    otDialog: otDialog,
    AttendanceDetailsDialog: AttendanceDetailsDialog,
    BatchImportDialog: BatchImportDialog
  },
  data: function data() {
    return {
      otVisible: false,
      exportLoading: false,
      // 表格数据load
      loading: false,
      // 加班动态展示
      overTime: false,
      // 在职状态
      stateArr: [],
      checkList: [],
      checkArr: [],
      checkData: checkData(this),
      colors: colors(this),
      defaultProps: {},
      value: '',
      radio: '',
      form: {
        page: 1,
        page_size: 20,
        start_date: '',
        end_date: '',
        states: ['1', '3']
      },
      tableData: [{}],
      options: [],
      props: {},
      dataCloumn: {
        d: 31
      },
      timeArr: [],
      // 动态计算表格高度
      heightTab: 0,
      isPunchDialog: false,
      batchImportDialogVisiable: false // 考勤批量导入
    };
  },
  created: function created() {
    this.handleCloumn();
    this.sysInfoFn();
  },
  mounted: function mounted() {
    this.handleGetAttendance();
  },
  methods: {
    // @parma { Object } row 当前行
    // @parma { Number } ot_type 加班类型
    // @parma { Number } title 加班类型翻译key
    handlerOtClick: function handlerOtClick(row, ot_type, title) {
      var _this = this;
      var msg = _objectSpread(_objectSpread(_objectSpread({}, this.form), row), {}, {
        title: title,
        ot_type: ot_type
      });
      this.otVisible = true;
      this.$nextTick(function () {
        _this.$refs.otDia.handlerGetData(msg);
      });
    },
    // 获取在职状态
    sysInfoFn: function sysInfoFn() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _sysInfoFn();
            case 2:
              res = _context.sent;
              _this2.stateArr = res.data.state;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 日期筛选赋值
    handlerInputChange: function handlerInputChange(obj) {
      if (obj && Array.isArray(obj) && obj.length) {
        this.form.start_date = obj[0];
        this.form.end_date = obj[1];
      }
    },
    // 表格数据格式化
    formateValue: function formateValue(val, str) {
      return val && val[str] || '';
    },
    formateRemark: function formateRemark(val, type) {
      var key = type === 'in' ? 'start_remark' : 'end_remark';
      return val && val[key] ? val[key] : 'empty';
    },
    // 搜索
    handlerSearch: function handlerSearch() {
      this.form.page = 1;
      this.handleGetAttendance();
    },
    // 部门选择
    handlerChangeDep: function handlerChangeDep(a, b) {
      this.form.department_id = b.slice(-1)[0];
    },
    // 左侧checkbox change事件
    handlerChangeSelect: function handlerChangeSelect(v) {
      var _this3 = this;
      var arr = [];
      v.forEach(function (element) {
        _this3.checkData.forEach(function (item) {
          if (item.label === element) {
            arr.push(item);
          }
        });
      });
      this.checkArr = arr;
      // this.$nextTick(() => this.$refs.table.doLayout && this.$refs.table.doLayout())
    },
    // 生成key
    createKey: function createKey() {
      return new Date().getTime();
    },
    // 生成表格列循环月key
    createLabel: function createLabel(item) {
      return "0".concat(this.dataCloumn.m, "-").concat(item < 9 ? '0' + (item + 1) : item + 1);
    },
    // 表格循环颜色标注
    colorStr: function colorStr(val, str) {
      if (!val || !val[str]) return '#FFF';
      val = Number(val[str]);
      var mapColors = new Map([[1, this.colors[0].color], [2, this.colors[1].color], [3, this.colors[2].color], [4, this.colors[3].color]]);
      return mapColors.get(val) || '#FFF';
    },
    //  分页相关
    handleSizeChange: function handleSizeChange(val) {
      this.form.page_size = val;
      this.handleGetAttendance();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.form.page = val;
      this.handleGetAttendance();
    },
    // 获取考勤统计数据
    handleGetAttendance: function handleGetAttendance() {
      var _this4 = this;
      this.loading = true;
      getAttendance(this.form).then(function (res) {
        var data = res.data;
        _this4.form.count = data.count;
        _this4.tableData = data.datalist;
        _this4.timeArr = data.days;
        // this.$nextTick(() => this.$refs.table.doLayout && this.$refs.table.doLayout())
      }).finally(function () {
        _this4.loading = false;
      });
    },
    formateTimeOwon: function formateTimeOwon(arr) {
      var _arr = _slicedToArray(arr, 2),
        start = _arr[0],
        end = _arr[1];
      var currentTime = new Date(start.split('')[0]).getTime();
      var endTime = new Date(end.split('')[0]).getTime();
      while (currentTime < endTime) {
        var time = this.$util.parseTime(new Date(currentTime), 'm-d');
        this.timeArr.push(time);
        currentTime += 86400000;
      }
    },
    // 初始化时间
    handleCloumn: function handleCloumn() {
      var date = new Date();
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      var d = date.getDate();
      this.dataCloumn = {
        y: y,
        m: m,
        d: d
      };
      this.form.start_date = "".concat(y, "-").concat(m, "-1");
      this.form.end_date = "".concat(y, "-").concat(m, "-").concat(d);
    },
    handlerAttendanceExcel: function handlerAttendanceExcel() {
      var _this5 = this;
      if (this.exportLoading) return;
      this.exportLoading = true;
      attendanceExcel(this.form).then(function (res) {
        window.open(res.data.object_url);
        setTimeout(function () {
          _this5.exportLoading = false;
        }, 200);
      }).catch(function () {
        _this5.exportLoading = false;
      });
    },
    canClick: function canClick() {
      var _arguments = arguments,
        _this6 = this;
      this.isPunchDialog = true;
      this.$nextTick(function () {
        var _this6$$refs$punchDi;
        return (_this6$$refs$punchDi = _this6.$refs['punch-dialog']).init.apply(_this6$$refs$punchDi, _toConsumableArray(_arguments));
      });
    },
    openAttendanceDetailsDialog: function openAttendanceDetailsDialog(params) {
      this.$refs.AttendanceDetailsDialog.init(params);
    },
    /**
     * @description: 批量导入考勤
     * @return {*}
     */
    doBatchImportFn: function doBatchImportFn() {
      this.batchImportDialogVisiable = true;
    },
    /**
     * @description: 批量导入考勤成功
     * @return {*}
     */
    doBatchImportSuccess: function doBatchImportSuccess(result, file) {
      // 1. toast提示 => 导入任务已提交，详情请查看下载列表(导航栏右上角-切换语言按钮旁)，请耐心等待
      this.$message.success(this.$t('25134_415d459d'));

      // 2. 关闭弹窗
      this.batchImportDialogVisiable = false;
    }
  }
};